module.exports = __webpack_public_path__ + "img/clou01.0675e96e.png";